// extracted by mini-css-extract-plugin
export default {"subtitle":"Terms_subtitle__6Bi1l"};